function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import React, { Component } from "react";
import { connect } from "react-redux";
import Spinner from "@common/components/Spinner";
import { replaceWith } from "@common/services/helpers";
var Confirmation = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Confirmation, Component);
    var _super = _create_super(Confirmation);
    function Confirmation(props) {
        _class_call_check(this, Confirmation);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            confirmationPending: false
        };
        return _this;
    }
    _create_class(Confirmation, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var modalProps = this.props.modal.confirmationModalProps;
                if (modalProps.hasClickableElements) {
                    modalProps.messageClickableElements.map(function(clickableElement) {
                        var element = document.getElementById(clickableElement.id);
                        element.addEventListener("click", clickableElement.onClickMethod);
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var modalProps = this.props.modal.confirmationModalProps;
                if (modalProps.hasClickableElements) {
                    modalProps.messageClickableElements.map(function(clickableElement) {
                        var element = document.getElementById(clickableElement.id);
                        element.removeEventListener("click", clickableElement.onClickMethod);
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, modal = _this_props.modal;
                var modalProps = modal.confirmationModalProps;
                var message = "";
                if (modalProps.hasClickableElements) {
                    var elements = modalProps.messageClickableElements.map(function(clickableElement) {
                        return clickableElement.element;
                    });
                    message = /*#__PURE__*/ _jsx("span", {
                        dangerouslySetInnerHTML: {
                            __html: replaceWith(modalProps.message, _to_consumable_array(elements))
                        }
                    });
                }
                var buttons = [
                    /*#__PURE__*/ _jsx(Button, {
                        classes: {
                            label: "ux-button-label"
                        },
                        onClick: function() {
                            _this.setState({
                                confirmationPending: true
                            }, function() {
                                modalProps.confirmMethod();
                            });
                        },
                        className: "\n                button confirm-button raised pointer\n                ".concat(!modalProps.highlightConfirm ? " no-background" : ""),
                        children: modalProps.highlightConfirm && this.state.confirmationPending ? /*#__PURE__*/ _jsx(Spinner, {}) : /*#__PURE__*/ _jsx(_Fragment, {
                            children: modalProps.confirmButtonText || i18n.account.confirm
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        classes: {
                            label: "ux-button-label"
                        },
                        onClick: modalProps.declineMethod,
                        className: "\n                button close-button raised half-width pointer\n                ".concat(modalProps.highlightConfirm ? " no-background" : ""),
                        children: modalProps.declineButtonText || i18n.common.decline
                    })
                ];
                if (modalProps.flipButtons) {
                    buttons.reverse();
                }
                return /*#__PURE__*/ _jsx("div", {
                    className: "modal-overlay confirmation-overlay".concat(modalProps.hasClickableElements ? " lower-z-index" : ""),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "modal confirmation-wrapper",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "position-wrapper",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "message-wrapper",
                                    children: [
                                        modalProps.title ? /*#__PURE__*/ _jsx("span", {
                                            className: "title",
                                            children: modalProps.title
                                        }) : null,
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "message",
                                            children: message || modalProps.message
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "buttons-wrapper",
                                    children: buttons
                                })
                            ]
                        })
                    })
                });
            }
        }
    ]);
    return Confirmation;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, userDetails = param.userDetails, modal = param.modal;
    return {
        i18n: i18n,
        userDetails: userDetails,
        modal: modal
    };
};
export default connect(mapStateToProps)(Confirmation);
